<template>
  <div class="d-none d-lg-block py-1" id="navbar-navigation-content">
    <div class="container-menu">
      <b-navbar toggleable="lg" class="nav-navigation">
        <b-navbar-nav class="d-flex justify-content-between w-100">
          <li :style="$route.path == '/empleos' ? 'background: #df9234; width:8%;' : ''">
              <router-link to="/empleos"><span :style="$route.path == '/empleos' ? 'color:#fff;': ''"><i class="fas fa-briefcase"></i> Empleos</span></router-link>
          </li>
          <li :style="$route.path == '/cv' ? 'background: #df9234; width:8%;' : ''">
            <router-link to="/cv" class="nav-link"><span :style="$route.path == '/cv' ? 'color:#fff;': ''"><i class="far fa-user"></i> Mi CV</span></router-link>
          </li>
          <li :style="$route.path == '/cursos' ? 'background: #df9234; width:8%;' : ''">
            <router-link to="/cursos" class="nav-link"><span :style="$route.path == '/cursos' ? 'color:#fff;': ''"><i class="fas fa-graduation-cap"></i> Cursos</span></router-link>
          </li>
          <li :style="$route.path == '/empresas' ? 'background: #df9234; width:8%;' : ''">
            <router-link to="/empresas" class="nav-link"><span :style="$route.path == '/empresas' ? 'color:#fff;': ''"><i class="fas fa-building"></i> Empresas</span></router-link>
          </li> 
          <li :style="$route.path == '/blog' ? 'background: #df9234; width:8%;' : ''">
            <router-link to="/blog" class="nav-link"><span :style="$route.path == '/blog' ? 'color:#fff;': ''"><i class="fas fa-blog"></i> Blog</span></router-link>
          </li> 
          <!-- <li ><a href="https://blogkllaar.com/" target="_blank" class="nav-link"><i class="fas fa-blog"></i> Blog</a></li> -->
        </b-navbar-nav>
      </b-navbar>
    </div>
  </div>
</template>
<style scoped>
  #navbar-navigation-content{
    background-color: white;
    width: 100%;
    border-bottom: 1px solid lightgray; 
  }
  .router-link-exact-active{
    box-shadow: none !important;
    border: none !important;
  }
  .container-menu{
	  margin: 0 5vw;
  }
</style>
<script>
  export default {
    name: 'NavBarNavigation',
    mounted() {},
    computed: {
      currentRouteName() {
        return this.$route.name;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TheTopNavBarOptions.vue